import styles from './ProgressCheckpoints.module.css';

export type CheckpointState = 'pending' | 'active' | 'done';

export interface CheckpointItem {
  id: string;
  label: string;
  state: CheckpointState;
}

export interface ProgressCheckpointsProps {
  items: CheckpointItem[];
  ariaLabel?: string;
}

function Icon({ state }: { state: CheckpointState }): JSX.Element {
  if (state === 'done') {
    return (
      <svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true">
        <path d="M3 8.5l3 3 7-7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  if (state === 'active') {
    return <span className={styles.spinner} aria-hidden="true" />;
  }
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
      <circle cx="5" cy="5" r="4" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.5" />
    </svg>
  );
}

export function ProgressCheckpoints({ items, ariaLabel }: ProgressCheckpointsProps): JSX.Element {
  return (
    <ul
      className={styles.list}
      role="list"
      aria-label={ariaLabel}
      aria-live="polite"
    >
      {items.map((it) => (
        <li
          key={it.id}
          className={`${styles.row} ${styles[`row_${it.state}`]}`}
          data-state={it.state}
          aria-current={it.state === 'active' ? 'step' : undefined}
        >
          <span className={styles.iconWrap}><Icon state={it.state} /></span>
          <span className={styles.label}>{it.label}</span>
        </li>
      ))}
    </ul>
  );
}
